module.exports = __webpack_public_path__ + "img/Ic.455c727f.png";